module.exports = __webpack_public_path__ + "img/lappset-2023-nega.e4f2b6ca.png";